<template>
  <div class="submenu_permission">
    <div class="background-shapes">
      <div class="shape triangle-1"></div>
      <div class="shape triangle-2"></div>
      <div class="shape circle"></div>
    </div>
    <div class="row menu-form">
      <!-- Title Card -->
      <div class="col-12 mb-3">
        <b-card class="rounded-2 text-white bg-success shadow-lg">
          <h3 class="mb-0">{{ $t("Nisab Amount Update") }}</h3>
        </b-card>
      </div>

      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <div class="col-12">
          <b-card class="p-3">
            <div class="row">
              <div class="col-md-6 mb-3">
                <b-form-group
                  label="Currency Code"
                  class="text-uppercase requiredField"
                >
                <template v-slot:label>
                    {{ $t("Currency Code") }}
                  </template>
                  <b-form-input
                    v-model="formData.currencyCode"
                    id="nisab-id-1"
                    required
                    placeholder="Select currency code"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6 mb-3">
                <b-form-group label="Currency Icon" class="text-uppercase">
                    <template v-slot:label>
                    {{ $t("Currency Icon") }}
                  </template>
                  <b-form-input
                    v-model="formData.currencyIcon"
                    id="nisab-id-2"
                    required
                    placeholder="Select currency icon"
                  >
                  </b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6 mb-3">
                <b-form-group label="Nisab Amount" class="text-uppercase">
                    <template v-slot:label>
                    {{ $t("Nisab Amount") }}
                  </template>
                  <b-form-input
                    v-model="formData.nisabAmount"
                    id="nisab-id-3"
                    placeholder="Select nisab amount"
                    required
                  >
                  </b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  label="Status"
                  label-for="radios-btn-default"
                  class=""
                >
                  <template v-slot:label>
                    {{ $t("Status") }}
                  </template>
                  <b-form-radio-group
                    id="btn-radios-1"
                    v-model="formData.activeYn"
                    :options="optionsStatus"
                    :aria-describedby="ariaDescribedby"
                    :button-variant="
                      formData.activeYn == 'false'
                        ? 'outline-danger'
                        : 'outline-success'
                    "
                    name="active_status"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <b-button type="submit" variant="info" class="text-white">{{
                $t("Save")
              }}</b-button>
              <b-button type="reset" variant="outline-danger">{{
                $t("Clear")
              }}</b-button>
            </div>
          </b-card>
        </div>
      </b-form>
      <div class="card p-4 mt-4 row">
        <div class="col-md-12">
          <h4 class="rounded text-white bg-success p-4">{{ $t("Nisab List") }}</h4>
        </div>

        <div class="card-body mt-4 col-md-12 col-12">
          <!-- Add table-responsive wrapper here -->
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th v-for="(header, index) in headers" :key="index">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in nisabData" :key="item.id">
                  <td v-for="(header, hIndex) in headers" :key="hIndex">
                    <template v-if="header.value === 'action2'">
                      <a class="btn text-dark" @click="edit(item)">
                        <font-awesome-icon icon="pen-to-square" />
                      </a>
                    </template>
                    <template v-else>
                      {{ item[header.value] }}
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";

export default {
  name: "nisabaSave",
  components: {},
  data() {
    return {
      formData: {
        currencyCode: "",
        currencyIcon: "",
        nisabAmount: "",
        activeYn: "Y",
      },
      currencyOptions: [],
      optionsStatus: [
        { text: this.$t("Active"), value: "Y" },
        { text: this.$t("Inactive"), value: "N" },
      ],
      headers: [
        { text: "SL No", value: "sl" },
        { text: "Currency Code", value: "currencyCode" },
        { text: "Currency Icon", value: "currencyIcon" },
        { text: "Nisab Amount", value: "nisabAmount" },
        { text: "Active Status", value: "activeStatus" },
        { text: "Action", value: "action2" },
      ],
      nisabData: [],
    };
  },
  mounted() {
    this.getNisabData();
  },
  methods: {
    onSubmit() {
      apiRepository
        .currencyCodeUpdate(this.formData)
        .then((res) => {
          toast.success(res.data);
          this.getNisabData();
          this.onReset();
        })
        .catch((error) => {
          console.error("API Error:", error);
          toast.error(error?.response?.data || "Something went wrong");
        });
    },
    edit(item) {
      this.formData = {
        id: item.id,
        currencyCode: item.currencyCode,
        currencyIcon: item.currencyIcon,
        nisabAmount: item.nisabAmount,
        activeYn: item.activeYn,
      };
    },
    getNisabData() {
      apiRepository.getNisab().then((res) => {
        this.nisabData = res.data.map((item, index) => ({
          ...item,
          sl: index + 1,
          activeStatus: item.activeYn ? "Active" : "Inactive",
        }));
      });
    },

    onReset() {
      this.formData = {
        currencyCode: "",
        currencyIcon: "",
        nisabAmount: "",
        activeYn: "Y",
      };
    },
  },
};
</script>

<style scoped>
/*background style*/
.submenu_permission {
  position: relative;
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  border-radius: 15px;
  overflow: hidden;
}

.background-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
}

.triangle-1 {
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 200px solid rgba(255, 99, 71, 0.3);
  top: -50px;
  left: -50px;
  transform: rotate(45deg);
}

.triangle-2 {
  width: 0;
  height: 0;
  border-left: 80px solid transparent;
  border-right: 80px solid transparent;
  border-bottom: 160px solid rgba(70, 130, 180, 0.3);
  bottom: -80px;
  right: -80px;
  transform: rotate(-30deg);
}

.circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: rgba(144, 238, 144, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.menu-form {
  position: relative;
  z-index: 2;
  /*background: rgba(255, 255, 255, 0.9);*/
  padding: 2rem;
  border-radius: 10px;
  /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
  animation: fadeIn 0.5s ease-in-out;
}

.requiredField label::after {
  content: " *"; /* Add asterisk */
  color: red; /* Make it red */
  font-weight: bold;
}
</style>
